import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  submitButtonSeciton: {
    marginTop: 32,
    marginBottom: 40,
    '& button': {
      width: '100%',
      '& svg': {
        fill: colorSet.gray700
      },
      [theme.breakpoints.down('xs')]: {
        '&:not(:last-child)': {
          marginBottom: 24
        }
      }
    },
    '& .login-btn': {
      marginTop: 16
    }
  }
}));
